export default '/build/5604f915.svg'